import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useRoles from '~/hooks/useRoles';
import { Card, CardBody, Col, Collapse, Row } from 'reactstrap';
import { LG } from '~/util/breakpointWidths';
import { defineExpandedState } from '~/util/newLayoutHelpers';
import { maskCPF, maskEmail, maskPhone } from '~/util/mask';
import { logPiiRevealOnce } from '~/services/audit';

const CustomerDataCard = ({ cart, customer }) => {
  const windowSize = useSelector(({ layout }) => layout.windowSize);
  const [expanded, setExpanded] = useState(defineExpandedState(windowSize, LG));
  const { isSupport } = useRoles();
  const [reveal, setReveal] = useState(false);

  useEffect(() => {
    setExpanded(defineExpandedState(windowSize, LG));
  }, [windowSize]);

  useEffect(() => {
    if (!expanded) setReveal(false);
  }, [expanded]);

  const canReveal = !!isSupport;
  const showFull = canReveal && reveal;

  const name = customer?.name || cart.client?.name || '-';
  const phone = customer?.telephone || cart.client?.telephone || null;
  const email = customer?.email || cart.client?.email || null;
  const cpf = customer?.cpf || cart.client?.cpf || null;

  return (
    <Card className="new-layout card">
      <CardBody className="new-layout card-body px-3 py-3">
        <Row className="w-100 mx-0">
          <Col className="w-100 px-0">
            <div
              className="w-100 font-size-16 font-weight-600 d-flex align-items-center cursor-pointer"
              onClick={() => setExpanded(v => !v)}
              role="button"
              tabIndex={0}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') setExpanded(v => !v);
              }}
            >
              <span className="ml-0 ml-lg-2">Cliente</span>
              <div className="ml-auto d-flex align-items-center">
                {canReveal && (
                  <button
                    type="button"
                    className="p-0 border-0 bg-transparent d-flex align-items-center text-gray-600 reveal-btn"
                    onClick={e => {
                      e.stopPropagation();

                      setReveal(prev => {
                        const next = !prev;

                        // só loga quando REVELA (false -> true)
                        if (next) {
                          logPiiRevealOnce({
                            referId: cart?.id,
                            referModel: 'App/Cart',
                            fields: ['cpf', 'email', 'telephone'],
                            scope: 'customer_card',
                          });
                        }

                        return next;
                      });
                    }}
                    aria-pressed={reveal}
                  >
                    <i
                      className={`las la-${
                        reveal ? 'eye-slash' : 'eye'
                      } font-size-18`}
                    />
                    <span className="ml-1 font-size-12">
                      {reveal ? 'Ocultar dados' : 'Revelar dados'}
                    </span>
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-link p-0 ml-3 text-gray-600"
                  onClick={e => {
                    e.stopPropagation();
                    setExpanded(v => !v);
                  }}
                  aria-label={expanded ? 'Recolher' : 'Expandir'}
                >
                  <i
                    className={`las la-${
                      expanded ? 'angle-up' : 'angle-right'
                    } font-size-20`}
                  />
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Collapse isOpen={expanded}>
          <Row className="w-100 mx-0 ml-lg-2 mr-4 mb-lg-4 mt-3">
            <Col className="pl-0 mb-2 mb-lg-0" xs={6} lg={3}>
              <div className="font-size-14 font-weight-600 text-gray-600 d-block">
                Nome
              </div>
              <div className="font-size-14 font-weight-400 text-black d-block">
                {name}
              </div>
            </Col>
            <Col className="px-0 mb-2 mb-lg-0" xs={6} lg={3}>
              <div className="font-size-14 font-weight-600 text-gray-600 d-block">
                Telefone
              </div>
              <div className="font-size-14 font-weight-400 text-black d-block">
                {showFull ? phone || '-' : maskPhone(phone)}
              </div>
            </Col>
            <Col className="px-0 mb-2 mb-lg-0" xs={6} lg={3}>
              <div className="font-size-14 font-weight-600 text-gray-600 d-block">
                E-mail
              </div>
              <div className="font-size-14 font-weight-400 text-black d-block pr-2">
                {showFull ? email || '-' : maskEmail(email)}
              </div>
            </Col>
            <Col className="px-0 mb-2 mb-lg-0" xs={6} lg={3}>
              <div className="font-size-14 font-weight-600 text-gray-600 d-block">
                CPF
              </div>
              <div className="font-size-14 font-weight-400 text-black d-block">
                {showFull ? cpf || '-' : maskCPF(cpf)}
              </div>
            </Col>
          </Row>
        </Collapse>
      </CardBody>
    </Card>
  );
};

export default CustomerDataCard;
